var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 flip-cards-container" },
        _vm._l(_vm.selectedMenuItem, function(option, index) {
          return _c("square-option", { key: index, attrs: { option: option } })
        }),
        1
      ),
      _c("div", { staticClass: "clearfix" })
    ]),
    _vm.canViewEmptyMessage
      ? _c("div", { staticClass: "tag-badge custom-tag-badge" }, [
          _vm._m(0),
          _c("span", { staticClass: "tag-badge-title py-1 pl-2 at-badge" }, [
            _vm._v("Alertas")
          ])
        ])
      : _vm._e(),
    _vm.alerts.length > 0
      ? _c("div", { staticClass: "row mx-0" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c("custom-carousel", {
                  attrs: { items: _vm.alerts, "size-per-slide": _vm.slideSize },
                  on: { "go-to-details": _vm.goToDetailsHandler }
                })
              ],
              1
            )
          ])
        ])
      : _vm._e(),
    _vm.alerts.length == 0 && _vm.canViewEmptyMessage
      ? _c("div", { staticClass: "alert-empty-container" }, [_vm._m(1)])
      : _vm._e(),
    _c("div", { staticClass: "row mx-0 mt-5" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-4" },
        [
          _c("inbox", {
            ref: "_messagesInbox",
            attrs: {
              "download-document": _vm.downloadDocument,
              "get-messages": _vm.getInboxMessages
            }
          }),
          _c("confidentiality-agreement", {
            attrs: {
              "app-name": "Portal de Proveedor",
              "certification-request": _vm.completeUserAgreement,
              value: _vm.needUserCertification
            },
            on: { input: _vm.userAgreementVisibilityHandler }
          }),
          _c("ImmediateMessagePopup", {
            ref: "_immediateMessagePopupRef",
            attrs: {
              id: "immediateMessagePopup",
              items: _vm.immediateMessages
            },
            on: { "message-marked-as-read": _vm.onMarkedAsRead }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 col-md-8" },
        [
          _c("compact-calendar", {
            attrs: { items: _vm.schedule },
            on: { onDayChange: _vm.onDayChange }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "dot custom-dot text-center pl-1" }, [
      _c("em", {
        staticClass:
          "orange-icon orange-icon-badge-align fas fa-exclamation-circle"
      })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert-empty-container__wrapper" }, [
      _c("em", { staticClass: "fal fa-unlink" }),
      _c("span", [_vm._v("Actualmente no cuenta con alertas en sistema.")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }